module.exports = __webpack_public_path__ + "static/media/Sandogh.3a15e423.png";